import styled from 'styled-components'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// icons
import ActionIconOrigin from '@mui/icons-material/VerticalSplit'
import MeasureIconOrigin from 'src/icons/measures.svg'
import ObjectiveIconOrigin from '@mui/icons-material/TrackChanges'
// themes
import { colors } from 'themes/index'
// utils
import { darken, size } from 'polished'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 12px;
  max-width: 1200px;

  form {
    width: 100%;
  }
`

export const AddButton = styled.div`
  color: ${colors.blue500};
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${darken(0.1, colors.blue500)};

    svg path {
      fill: ${darken(0.1, colors.blue500)};
    }
  }

  & > span {
    margin-left: 8px;
    white-space: nowrap;
  }
`

export const MenuWrapper = styled.div`
  padding: 8px 0;
  color: ${colors.blue500};
`

export const MenuItem = styled(MenuItemOrigin)`
  && {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

export const ObjectiveIcon = styled(ObjectiveIconOrigin)`
  && {
    ${size('18px')};
    color: ${colors.blue500};
  }
`

export const ActionIcon = styled(ActionIconOrigin)`
  && {
    ${size('18px')};
    color: ${colors.blue500};
  }
`

export const MeasureIcon = styled(MeasureIconOrigin)`
  ${size('18px')};

  path {
    fill: ${colors.blue500};
  }
`
